<template>
  <el-dialog title="确认回款操作" :visible.sync="confirmReturnedShow" :close-on-click-modal="false" width="1000px"
    ref="dialog" @close="close">
    <ul class="list-ul" v-if="showRowDetail">
        <li v-for="(item, index) in huikunaList" :key="index">
            <div>
                <span><i>￥{{ item.JobTotalAmount }}</i> {{ item.AmountRemark }}</span>
                <p>【{{ item.ProvinceName}} {{ item.CityName }} 】{{ item.JobTitle }}</p>
                <p>{{ item.JobNo }}</p>
            </div>
             <p v-if="from === 'offlineInvoiceDetail'" class="return-price" :class="{hightlight: item.editReturnPrice }">回款金额：￥{{ item.editReturnPrice  | formatPrice }}
            </p>
            <p v-else class="return-price" :class="{ hightlight: !item.JobWaitReceivedMoney||(item.editReturnPrice==item.JobWaitReceivedMoney),editlight: item.JobReceivedMoney }">回款金额：￥{{ item.JobReceivedMoney  | formatPrice }}
                <el-input-number class="return-edit" v-if="returnAmount && item.JobWaitReceivedMoney&&item.JobWaitReceivedMoney>0" v-model="item.editReturnPrice" :controls="false" :min="0" :max="item.JobWaitReceivedMoney" label="请输入回款金额"></el-input-number>
                <el-input-number class="return-edit" v-else-if="returnAmount && item.JobWaitReceivedMoney&&item.JobWaitReceivedMoney<0" v-model="item.editReturnPrice" :controls="false" :min="item.JobWaitReceivedMoney" :max="0" label="请输入回款金额"></el-input-number>
            </p>
        </li>
        <p v-if="from === 'offlineInvoiceDetail'" class="yellow-tips">提示：发票金额与工单金额不一致，不可回款操作 </p>
    </ul>
    <el-form  v-if="showRowDetail" class="form-type1" :inline="true" label-position="left">
        <el-form-item label="发票金额：">
            <!-- TIPS：如果返回数据是100.00 不需要后续方法 -->
            <div>￥{{ totalAmount  | formatPrice }}</div>
        </el-form-item>
        <el-form-item v-if="from === 'detailsInvoice'" label="剩余应收金额">
            <div>￥{{ (remainAmount - returnAmount) | formatPrice}} </div>
        </el-form-item>
        <el-form-item v-if="from === 'offlineInvoiceDetail'" label="工单总计金额：" required>
            <div>￥{{ info.JobTrueTotalRealAmount  | formatPrice }}</div>
        </el-form-item>
        <el-form-item v-if="from === 'detailsInvoice'" label="本次回款金额：" required>
             <el-input-number v-model="returnAmount" :controls="false" @change="handledEdit" :min="0" :max="remainAmount" label="请输入回款金额"></el-input-number>
        </el-form-item>
        <el-form-item label="银行到账时间：">
            <el-date-picker v-model="editTime" type="date" placeholder="请选择日期" :picker-options="pickerOptions"  value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <p>
            <el-input type="textarea" :rows="4" placeholder="请输入备注"  v-model="editRemark" :maxlength="100" />
        </p>
        <br />
        <p class="red-tips">注：实际到账金额可能用于多张发票回款操作，若本次回款额度已用部分于其它发票，请注意扣除已用额度！ </p>
        <br />
        <el-button class="submit-btn" type="primary"  size="medium" @click="submit()">确认回款</el-button>
    </el-form>

    <el-form v-if="!showRowDetail" class="form-type2" label-position="left" label-width="120px">
        <el-form-item label="发票金额：">
            <!-- TIPS：如果返回数据是100.00 不需要后续方法 -->
            <div>￥{{ totalAmount | formatPrice }}</div>
        </el-form-item>
        <el-form-item label="已收款金额：">
            <div>￥{{ (info&&info.ReceivedMoney) | formatPrice }}</div>
        </el-form-item>
        <el-form-item label="剩余应收金额：" v-if="info">
            <div>￥{{ remainAmount - returnAmount | formatPrice }}</div>
        </el-form-item>
        <el-form-item label="回款金额：" required>
            <el-input size="medium" placeholder="请输入回款金额" v-model="returnAmount"></el-input>
        </el-form-item>
        <el-form-item label="银行到账时间：">
            <el-date-picker v-model="editTime" type="date" placeholder="请选择日期" :picker-options="pickerOptions"  value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注：">
            <el-input type="textarea" :rows="4" placeholder="请输入备注"  v-model="editRemark" :maxlength="100" />
        </el-form-item>
        <br />
        <el-form-item label=" ">
            <el-button type="primary" size="medium" @click="submit()">确 定</el-button>
        </el-form-item>
    </el-form>
</el-dialog>
</template>

<script>
import {
    getStorageUserRoleId,
} from '@/utils/store'
import {
    returnPayments,
    OfflineInvoiceConfirmReturnMoney,
    GetInvoiceJobInfo
} from "@/service/payApi";
export default {
    props: {
        from: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            returnAmount: '',
            editRemark: '',
            editTime: '',
            confirmReturnedShow: false,      //确认回款dialog
            info: {},
            showRowDetail: false,
            id: '',
            huikunaList: [],
            huikunaListDefalut: [],
            pickerOptions: {
                shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                        text: '明天',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                        text: '后天',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
                        picker.$emit('pick', date);
                    }
                }]
                },
        }
    },
    computed: {
        // 剩余应收总计
        remainAmount() {
            let info = this.info;
            return parseFloat((info.InvoiceMoney - info.ReceivedMoney).toFixed(2));
        },
        // 发票总金额
        totalAmount() {
            let info = this.info;
            return (info&&info.InvoiceMoney)
        }
    },
    methods: {
        open(info, id, showRowDetail = false) {
            this.returnAmount = "";
            this.editTime = '';
            this.confirmReturnedShow = true;
            this.info = info;
            this.id = id;
            this.editRemark = info.ReceiveMoneyRemark || "";
            this.showRowDetail = showRowDetail;
            if (this.showRowDetail && this.from === 'detailsInvoice') {
                this.GetInvoiceJobInfoFun(1)
            }
            if (this.showRowDetail && this.from === 'offlineInvoiceDetail') {
                this.GetInvoiceJobInfoFun(2)
            }
        },
        close() {
            this.confirmReturnedShow = false
        },
        async GetInvoiceJobInfoFun(type) {
            let res = await GetInvoiceJobInfo({Id: this.id, InvoiceType: type });
            if (res.Result != 1) {
                return this.$message.error(res.Message)
            }
            this.huikunaListDefalut = res.Data.InvoiceJobList;
            console.log('type:'+type)

            if (type === 1) {
                this.resetEditData()
            }
            if (type === 2) {
                this.resetEditData2()
            }
        },
        resetEditData() {
            this.huikunaListDefalut.map(item => {
                item.JobTotalAmount = item.JobTotalAmount.toFixed(2)
                item.editReturnPrice = 0
            })
            this.huikunaList = JSON.parse(JSON.stringify(this.huikunaListDefalut))
        },
        resetEditData2() {
            this.huikunaListDefalut.map(item => {
                item.JobTotalAmount = item.JobTotalAmount.toFixed(2)
                item.editReturnPrice = item.JobTotalAmount
                item.JobReceivedMoney = 0;
            })
            this.huikunaList = JSON.parse(JSON.stringify(this.huikunaListDefalut))
            this.returnAmount = this.info.InvoiceMoney;
        },
        //线上回款=提交
        submit() {
            if (!this.returnAmount) {
                this.$message.error('回款金额不能为空')
                return
            }
             if (!this.editTime) {
                this.$message.error('请选择银行到账时间')
                return
            }
            console.log('this.form:'+this.from)
            if (this.from === 'offlineInvoiceDetail') {
                this.submit2()
                return;
            }
            var data = {
                ReceiveAccount: this.info.BankNo,
                Id: this.id,
                ManageUserId: getStorageUserRoleId(),
                Platform: 'zyd',
                ReceiveMoney: this.returnAmount,
                InvoiceReturnPaymentsDt: this.editTime,
                ReceiveMoneyRemark: this.editRemark || ""
            }
            if (this.showRowDetail) {
                data.JobOrNoteList = [];
                let computedAllPrice = 0;
                this.huikunaList.map(item => { 
                    let newItem = { Id: item.Id, ReceiveMoney: item.editReturnPrice  }
                    if (newItem.ReceiveMoney) {
                        data.JobOrNoteList.push(newItem)
                        computedAllPrice +=  Number(item.editReturnPrice)
                    }
                })
                computedAllPrice=Number(computedAllPrice.toFixed(2));
                 // 编辑的每一行的总金额 ！= 总编辑的金额，提示不给提交
                if (computedAllPrice != this.returnAmount) {
                    console.log("computedAllPrice != this.returnAmount",computedAllPrice ,this.returnAmount)
                    this.$message.error('请确认回款总金额和每一行工单的累加金额一致')
                    return;
                }
            }
              
            returnPayments(data).then((r) => {
                if (r.Result != 1) {
                    return this.$message.error(r.Message)
                }
                this.$message.success('确认回款成功')
                this.close()
                this.$emit("confirmReturnSuccess")
            })
        },
         //线下回款提交
        submit2() {
            var data = {
                ReceiveAccount: this.info.SpBankNo,
                Id: this.id,
                ReceiveMoney: this.returnAmount,
                InvoiceReturnPaymentsDt: this.editTime,
                ReceiveMoneyRemark: this.editRemark || ""
            }
            if (this.showRowDetail) {
                data.JobOrNoteList = [];
                let computedAllPrice = 0;
                this.huikunaList.map(item => { 
                    item.editReturnPrice=Number(item.editReturnPrice);
                    let newItem = { Id: item.Id, ReceiveMoney: item.editReturnPrice }
                    if (item.editReturnPrice) {
                        data.JobOrNoteList.push(newItem)
                        computedAllPrice +=  item.editReturnPrice
                    }
                })
                console.log('computedAllPrice:'+computedAllPrice);
                // 编辑的每一行的总金额 ！= 总编辑的金额，提示不给提交
                if (computedAllPrice != this.returnAmount) {
                    console.log("computedAllPrice != this.returnAmount",computedAllPrice ,this.returnAmount)
                    this.$message.error('请确认回款总金额和每一行工单的累加金额一致')
                    return;
                }
            } 

            OfflineInvoiceConfirmReturnMoney(data).then((r) => {
                if (r.Result != 1) {
                    return this.$message.error(r.Message)
                }
                this.$message.success('确认回款成功')
                this.close()
                this.$emit("confirmReturnSuccess")
            })
        },
        handledEdit() {
            console.log('1')
            console.log('returnAmount：'+this.returnAmount)
            if (!this.returnAmount) {
                this.returnAmount = 0;
            }
            console.log('2')

            let { returnAmount, totalAmount, remainAmount } = this;
            if (returnAmount < 0) {
                this.$message.error('输入的回款金额不能小于等于0')
            }
            console.log('3')

            if (returnAmount == 0) {
                this.huikunaList.map(item => {
                    item.editReturnPrice = 0;
                    return item;
                })
                return;
            }
            console.log('4')

            this.returnAmount = this.returnAmount.toFixed(2);
            this.huikunaList.map(item => {
                if (!item.JobWaitReceivedMoney) {
                    item.editReturnPrice = 0;
                    return;
                }
            console.log('5')

                const k = returnAmount - item.JobWaitReceivedMoney;
                // console.log('k:'+k)
                if (k > 0) {
                    item.editReturnPrice = item.JobWaitReceivedMoney;
                    returnAmount = returnAmount - item.JobWaitReceivedMoney;
                } else {
                    item.editReturnPrice =returnAmount.toFixed(2);
                    returnAmount = 0;
                }
                //   console.log('returnAmount:'+returnAmount)
                return item;
            });
            console.log('this.returnAmount 2:'+this.returnAmount)

        }
    }
}
</script>

<style lang="scss" scoped>
p {
    margin: 0;
}
ul.list-ul {
    margin-bottom: 20px;
    max-height: 330px;
    overflow: auto;
    display: inline-block;
    width: 100%;
    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 3px;
        div {
            width: 63%;
            border-bottom: 1px solid #e5e5e5;
            p {
                line-height: 1.7;
            }
            span {
                float: right;
                line-height: 48px;
                i {
                    font-size: 16px;
                    font-style: normal;
                }
            }
        }
        .return-price {
            width: 29%;
            min-height: 46px;
            line-height: 46px;
            border-radius: 2px;
            text-align: center;
        }
        .return-edit {
            width: 120px;
        }
        .editlight {
            background: rgba(249,146,146,0.8);
        }
        .return-price.hightlight {
            background: rgba(103, 194, 58, 0.4);
        }
    }
}
.submit-btn {
    margin: 0 auto;
    display: block;
}
.red-tips {
    color: red;
}
.yellow-tips {
    color: #e6a23c;  
}
.form-type1 {
    ::v-deep .el-input__inner {
        width: 160px
    }
    .el-form-item {
        width: 450px;
        background-color: #f9f9f9;
        border: solid 1px #e5e5e5;
        padding: 0 10px;
        margin-right: 0;
    }
    .el-form-item:nth-child(odd) {
        margin-right: 15px;
    }
}
</style>